import { createContext, useContext, useEffect, useState } from "react";
import { useGetLevelList } from "../hooks/userLevelList/userLevelList.hooks";

const UserLevelListContext = createContext({
  levelListLength: 0,
  levelList: [],
  isLevelListLoading: false,
  isLevelListError: false,
  levelListError: null,
});

export const UserLevelListContextProvider = ({ children }) => {
  const [levelListLength, setLevelListLength] = useState(6);

  const {
    data: levelList,
    isLoading: isLevelListLoading,
    isError: isLevelListError,
    error: levelListError,
  } = useGetLevelList({
    options: {
      cacheTime: 3 * 60 * 1000,
      staleTime: 3 * 60 * 1000, // 3 minutes
    },
  });

  useEffect(() => {
    // console.debug("levelList", levelList);
    if (levelList) {
      setLevelListLength(levelList.length - 1);
    }
  }, [levelList]);

  return (
    <UserLevelListContext.Provider
      value={{ levelListLength, levelList, isLevelListLoading, isLevelListError, levelListError }}
    >
      {children}
    </UserLevelListContext.Provider>
  );
};
export const useUserLevelList = () => {
  const UserLevelListView = useContext(UserLevelListContext);
  return UserLevelListView;
};
